import { Panel } from '../panel.class';

export const isBackPanelCfn = (panel: Panel, frontPanelId: string | null): boolean => {
	// can't determine back panel without island frontpanelid
	if (frontPanelId === null) return false;

	// can't be the side panel if it's the front panel
	if (panel.id === frontPanelId) return false;

	// a back panel is never connnected to a front panel
	return panel.connections?.left?.targetPanelId !== frontPanelId &&
		panel.connections?.right?.targetPanelId !== frontPanelId;
};
